import { createSelector } from '@reduxjs/toolkit';
import { isDirty } from 'redux-form';

import {
  FORM_THEME_EDITOR_ADVANCED_NAME,
  FORM_THEME_EDITOR_BUTTONS_NAME,
  FORM_THEME_EDITOR_COLOR_NAME,
  FORM_THEME_EDITOR_COMPLETION_PAGE_NAME,
  FORM_THEME_EDITOR_DOCUMENTS_UPLOAD_PAGE_NAME,
  FORM_THEME_EDITOR_FAILED_PAGE_NAME,
  FORM_THEME_EDITOR_FONT_NAME,
  FORM_THEME_EDITOR_SELECT_COUNTRY_PAGE_NAME,
  FORM_THEME_EDITOR_START_PAGE_LOGO_NAME,
  FORM_THEME_EDITOR_START_PAGE_NAME,
} from 'dashboard/lib/constants/formNames';

export const isThemeEditorFormDirty = createSelector(
  [
    isDirty(FORM_THEME_EDITOR_ADVANCED_NAME),
    isDirty(FORM_THEME_EDITOR_BUTTONS_NAME),
    isDirty(FORM_THEME_EDITOR_COLOR_NAME),
    isDirty(FORM_THEME_EDITOR_COMPLETION_PAGE_NAME),
    isDirty(FORM_THEME_EDITOR_FAILED_PAGE_NAME),
    isDirty(FORM_THEME_EDITOR_FONT_NAME),
    isDirty(FORM_THEME_EDITOR_SELECT_COUNTRY_PAGE_NAME),
    isDirty(FORM_THEME_EDITOR_DOCUMENTS_UPLOAD_PAGE_NAME),
    isDirty(FORM_THEME_EDITOR_START_PAGE_NAME),
    isDirty(FORM_THEME_EDITOR_START_PAGE_LOGO_NAME),
  ],
  (
    isAdvancedDirty,
    isButtonsDirty,
    isColorDirty,
    isCompletionPageDirty,
    isFailedPageDirty,
    isFontDirty,
    isSelectCountryPageDirty,
    isDocumentsUploadPageDirty,
    isStartPageDirty,
    isStartPageLogoDirty,
  ) =>
    isAdvancedDirty ||
    isButtonsDirty ||
    isColorDirty ||
    isCompletionPageDirty ||
    isFailedPageDirty ||
    isFontDirty ||
    isSelectCountryPageDirty ||
    isDocumentsUploadPageDirty ||
    isStartPageDirty ||
    isStartPageLogoDirty ||
    false,
);
